import { EnumDataType } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { ConfigItem } from '@/api/com/MetaPattern/MDA/MD/APPModel/ConfigItem';
import { MenuItem } from '@/api/com/MetaPattern/MDA/MD/APPModel/MenuItem';
import { BEAttribute } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEAttribute';
import { BEServiceAction } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEServiceAction';
import { BLParameter } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BLParameter';
import { ConstantItem } from '@/api/com/MetaPattern/MDA/MD/EntityModel/ConstantItem';
import { DTAttribute } from '@/api/com/MetaPattern/MDA/MD/EntityModel/DTAttribute';
import { EntityMethod } from '@/api/com/MetaPattern/MDA/MD/EntityModel/EntityMethod';
import { EnumItem } from '@/api/com/MetaPattern/MDA/MD/EntityModel/EnumItem';
import { ESParameter } from '@/api/com/MetaPattern/MDA/MD/EntityModel/ESParameter';
import { InterfaceAttribute } from '@/api/com/MetaPattern/MDA/MD/EntityModel/InterfaceAttribute';
import { InterfaceMethod } from '@/api/com/MetaPattern/MDA/MD/EntityModel/InterfaceMethod';
import { MethodParameter } from '@/api/com/MetaPattern/MDA/MD/EntityModel/MethodParameter';
import { ValueObjectAttribute } from '@/api/com/MetaPattern/MDA/MD/EntityModel/ValueObjectAttribute';
import { ValueObjectMethod } from '@/api/com/MetaPattern/MDA/MD/EntityModel/ValueObjectMethod';
import { EnumPersistenceStatus } from '../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { APPComment } from '../../../../../api/com/MetaPattern/MDA/MD/APPModel/APPComment';
import { APPComponent } from '../../../../../api/com/MetaPattern/MDA/MD/APPModel/APPComponent';
import { ConfigGroup } from '../../../../../api/com/MetaPattern/MDA/MD/APPModel/ConfigGroup';
import { EnumAPPRelationshipType } from '../../../../../api/com/MetaPattern/MDA/MD/APPModel/EnumAPPRelationshipType';
import { MenuContain } from '../../../../../api/com/MetaPattern/MDA/MD/APPModel/MenuContain';
import { MenuSet } from '../../../../../api/com/MetaPattern/MDA/MD/APPModel/MenuSet';
import { APP } from '../../../../../api/com/MetaPattern/MDA/MD/Base/APP';
import { BaseComment } from '../../../../../api/com/MetaPattern/MDA/MD/Base/BaseComment';
import { BaseComponent } from '../../../../../api/com/MetaPattern/MDA/MD/Base/BaseComponent';
import { BaseElement } from '../../../../../api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { EnumComponentType } from '../../../../../api/com/MetaPattern/MDA/MD/Base/EnumComponentType';
import { Product } from '../../../../../api/com/MetaPattern/MDA/MD/Base/Product';
import { Aggregation } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/Aggregation';
import { Association } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/Association';
import { BEBusinessLogic } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEBusinessLogic';
import { BEComment } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEComment';
import { BEComponent } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEComponent';
import { BEConstant } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEConstant';
import { BEDistributedTransaction } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEDistributedTransaction';
import { BEDTO } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEDTO';
import { BEEntity } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEEntity';
import { BEEnum } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEEnum';
import { BEExternalService } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEExternalService';
import { BEInterface } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEInterface';
import { BEReferenceEntity } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEReferenceEntity';
import { BEService } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEService';
import { BEValueObject } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEValueObject';
import { Composition } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/Composition';
import { CrossAssociation } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/CrossAssociation';
import { DependencyAssociation } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/DependencyAssociation';
import { DTOAttribute } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/DTOAttribute';
import { EntityGeneration } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EntityGeneration';
import { EnumMultiplicity } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumMultiplicity';
import { EnumRelationshipType } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumRelationshipType';
import { Implement } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/Implement';
import { InterfaceGeneration } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/InterfaceGeneration';
import { ProductAPP } from '../../../../../api/com/MetaPattern/MDA/MD/ProductModel/ProductAPP';
import { ProductComment } from '../../../../../api/com/MetaPattern/MDA/MD/ProductModel/ProductComment';
import { ProductComponent } from '../../../../../api/com/MetaPattern/MDA/MD/ProductModel/ProductComponent';
import { ActionType } from '../../../../../api/com/MetaPattern/MDA/MD/UIModel/ActionType';
import { EnumPageType } from '../../../../../api/com/MetaPattern/MDA/MD/UIModel/EnumPageType';
import { EVOAction } from '../../../../../api/com/MetaPattern/MDA/MD/UIModel/EVOAction';
import { EVOAttribute } from '../../../../../api/com/MetaPattern/MDA/MD/UIModel/EVOAttribute';
import { UIModelComponent } from '../../../../../api/com/MetaPattern/MDA/MD/UIModel/UIModelComponent';
import { UIPage } from '../../../../../api/com/MetaPattern/MDA/MD/UIModel/UIPage';
import { UIPageGroup } from '../../../../../api/com/MetaPattern/MDA/MD/UIModel/UIPageGroup';
import { ViewObject } from '../../../../../api/com/MetaPattern/MDA/MD/UIModel/ViewObject';
import { IDEContext } from '../../Product/IDE/IDEContext';
import { GuidHelper } from '../../Product/IDE/Util/GuidHelper';
import { UniqueKeyManager } from './UniqueKeyManager';

/** 元数据的创建工厂 */
export class MDRepository {
  /** 创建产品 */
  public static async createProductAsync(name: string, displayName: string, description: string, rootNamespace: string, workscopeId: string, sysAPP: APP): Promise<Product> {
    return new Promise((resolve, reject) => {
      const product = new Product();
      this.setBaseElementAsync(product, name, displayName)
        .then(() => {
          product.description = description;
          product.rootNamespace = rootNamespace;
          product.workScope_ID = workscopeId;
          // 产品组件
          this.createProductComponent(product, sysAPP, EnumComponentType.Product).then((component) => {
            component.name = product.name + 'Com';
            component.displayName = '产品组件';
            component.alias = component.name;
            component.description = product.description;
            component.rootNamespace = product.rootNamespace;
            resolve(product);
          });
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  /**
   * 根据组件类型创建Product组件
   * @param product 产品
   * @param sysAPP 系统应用
   * @param componentType 组件类型
   * @returns 新建的組件，修改狀態為Create
   */
  public static async createProductComponent(product: Product, sysAPP: APP, componentType: EnumComponentType): Promise<BaseComponent> {
    return new Promise((resolve, reject) => {
      let component: BaseComponent = null;
      switch (componentType) {
        case EnumComponentType.Product:
        case EnumComponentType.BE:
        case EnumComponentType.APP:
        case EnumComponentType.DB:
        default:
          if (product.productComponents.length === 0) {
            component = new ProductComponent();
            this.setBaseElementAsync(component, 'NewProductComponent', '新产品组件')
              .then(() => {
                component.componentType = componentType;
                component.rootNamespace = product.rootNamespace;
                component.product = product;
                // 产品组件中要预置系统应用
                const sysProductAPP = new ProductAPP();
                sysProductAPP.component = component as ProductComponent;
                sysProductAPP.aPP = sysAPP;
                this.setBaseElementAsync(sysProductAPP, sysAPP.name, sysAPP.displayName);
                sysProductAPP.description = sysAPP.description;
                (component as ProductComponent).productAPPs.push(sysProductAPP);
                // 组件添加到产品里面
                product.productComponents.push(component as ProductComponent);
                resolve(component);
              })
              .catch((error) => {
                reject(error);
              });
          } else {
            // component = product.productComponent as BaseComponent;
          }
          break;
      }
      if (component === null) {
        resolve(null);
      }
    });
  }

  /**
   * 创建新的应用，包括：
   * 1、应用
   * 2、应用组件
   * 3、外部服务组件，包括初始的Sys服务引用
   * @param name 应用名称
   * @param displayName 显示名称
   * @param description 描述
   * @param appKey APPKey
   * @param rootNamespace 根名字空间
   * @param workscopeId 工作空间ID
   * @returns 新创建的应用
   */
  public static async createNewAPPAsync(name: string, displayName: string, description: string, appKey: string, rootNamespace: string, workscopeId: string): Promise<APP> {
    return new Promise((resolve, reject) => {
      const app = new APP();
      this.setBaseElementAsync(app, name, displayName)
        .then(() => {
          app.description = description;
          app.aPPKey = appKey;
          app.rootNamespace = rootNamespace;
          app.workScope_ID = workscopeId;
          // 应用组件
          const component = this.createAPPComponent(app, EnumComponentType.APP);
          component.name = app.name + 'Com';
          component.displayName = '应用组件';
          component.alias = app.name + '_';
          component.description = app.description;
          component.rootNamespace = app.rootNamespace;
          resolve(app);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  /**
   * 根据组件类型创建APP组件
   * @param app 应用
   * @param componentType 组件类型
   * @returns 新建的組件，修改狀態為Create
   */
  public static createAPPComponent(app: APP, componentType: EnumComponentType): BaseComponent {
    let component: BaseComponent = null;
    switch (componentType) {
      case EnumComponentType.APP:
        if (app.aPPComponents.length === 0) {
          component = new APPComponent();
          this.setBaseElementAsync(component, 'NewAPPComponent', '新应用组件');
          component.componentType = componentType;
          component.aPP = app;
          component.rootNamespace = app.rootNamespace;
          component.alias = app.name + '_';
          app.aPPComponents.push(component as APPComponent);
        } else {
          // component = app.aPPComponent as BaseComponent;
        }
        break;
      case EnumComponentType.BE:
      default:
        component = new BEComponent();
        this.setBaseElementAsync(component, 'NewBEComponent', '新业务组件');
        component.componentType = componentType;
        component.aPP = app;
        component.rootNamespace = app.rootNamespace + '.';
        component.alias = app.name + '_';
        app.bEComponents.push(component as BEComponent);
        break;
    }

    if (component !== null && component.id === '') {
      component.aPP_ID = app.id;
      component.componentType = componentType;
    }
    return component;
  }

  /** ************************************************************* APPModel ********************************************** */
  /** 创建APP注释 */
  public static createAPPComment(component: APPComponent, isJoinComponent: boolean): APPComment {
    const comment = new APPComment();
    this.setComment(comment);
    if (component !== null) {
      if (isJoinComponent) {
        component.comments.push(comment);
      }
      comment.component = component;
    }
    return comment;
  }

  /** 创建菜单集 */
  public static createMenuSet(appComponent: APPComponent, isJoinComponent: boolean): MenuSet {
    const menuSet = new MenuSet();
    this.setBaseElementAsync(menuSet, 'MenuSet', '新建菜单集');
    if (appComponent !== null) {
      if (isJoinComponent) {
        appComponent.menuSets.push(menuSet);
      }
      menuSet.component = appComponent;
    }
    return menuSet;
  }

  /** 创建菜单项 */
  public static createMenuItem(menuSet: MenuSet): MenuItem {
    const element = new MenuItem();
    this.setBaseElementAsync(element, 'Menu', '新建菜单');
    if (menuSet !== null) {
      element.sequence = menuSet.menuItems.length;
      menuSet.menuItems.push(element);
      element.menuSet = menuSet;
    }
    return element;
  }

  /** 创建配置分组 */
  public static createConfigGroup(appComponent: APPComponent, isJoinComponent: boolean): ConfigGroup {
    const configGroup = new ConfigGroup();
    this.setBaseElementAsync(configGroup, 'ConfigGroup', '新建配置分组');
    if (appComponent !== null) {
      if (isJoinComponent) {
        appComponent.configGroups.push(configGroup);
      }
      configGroup.component = appComponent;
    }
    return configGroup;
  }

  /** 创建配置项 */
  public static createConfigItem(configGroup: ConfigGroup): ConfigItem {
    const element = new ConfigItem();
    this.setBaseElementAsync(element, 'configItem', '新建配置项');
    if (configGroup !== null) {
      element.sequence = configGroup.configItems.length;
      configGroup.configItems.push(element);
      element.configGroup = configGroup;
    }
    return element;
  }

  /**
   * 创建菜单主子关系
   * @param appComponent 应用组件
   * @param mainMenuSet 主菜单
   * @param subMenuSet 子菜单
   */
  public static createMenuContain(appComponent: APPComponent, mainMenuSet: MenuSet, subMenuSet: MenuSet, isJoinComponent: boolean): MenuContain {
    const menuContain = new MenuContain();
    this.setBaseElementAsync(menuContain, 'MenuContain', '菜单主子关系');
    menuContain.aPPRelationshipType = EnumAPPRelationshipType.MenuContain;
    menuContain.mainMenuSet = mainMenuSet;
    menuContain.subMenuSet = subMenuSet;
    if (appComponent !== null) {
      if (isJoinComponent) {
        appComponent.menuContains.push(menuContain);
      }
      menuContain.aPPComponent = appComponent;
    }
    return menuContain;
  }

  /** ************************************************************* ProductModel ********************************************** */
  /** 创建Product注释 */
  public static createProductComment(component: ProductComponent, isJoinComponent: boolean): ProductComment {
    const comment = new ProductComment();
    this.setComment(comment);
    if (component !== null) {
      if (isJoinComponent) {
        component.comments.push(comment);
      }
      comment.component = component;
    }
    return comment;
  }

  /** 创建ProductAPP产品应用 */
  public static createProductAPP(component: ProductComponent, isJoinComponent: boolean): ProductAPP {
    const productAPP = new ProductAPP();
    this.setBaseElementAsync(productAPP, 'ProductAPP', '新建产品应用');
    productAPP.description = '请选择关联的应用';
    if (component !== null) {
      if (isJoinComponent) {
        component.productAPPs.push(productAPP);
      }
      productAPP.component = component;
    }
    return productAPP;
  }

  /** ************************************************************* EntityModel ********************************************** */
  /** 创建BE注释 */
  public static createBEComment(component: BEComponent, isJoinComponent: boolean): BEComment {
    const comment = new BEComment();
    this.setComment(comment);
    if (component !== null) {
      if (isJoinComponent) {
        component.comments.push(comment);
      }
      comment.component = component;
    }
    return comment;
  }

  /** 创建实体 */
  public static createEntity(component: BEComponent, isJoinComponent: boolean): BEEntity {
    const entity = new BEEntity();
    this.setBaseElementAsync(entity, 'Entity', '新建实体');
    if (component !== null) {
      if (isJoinComponent) {
        component.entities.push(entity);
      }
      entity.component = component;
    }
    return entity;
  }

  /** 创建实体属性 */
  public static createBEAttribute(entity: BEEntity): BEAttribute {
    const element = new BEAttribute();
    this.setBaseElementAsync(element, 'Attribute', '新建属性');
    if (entity !== null) {
      element.sequence = entity.attributes.length;
      entity.attributes.push(element);
      element.entity = entity;
    }
    return element;
  }

  /** 创建实体方法 */
  public static createEntityMethod(entity: BEEntity): EntityMethod {
    const element = new EntityMethod();
    this.setBaseElementAsync(element, 'method', '新建方法');
    if (entity !== null) {
      element.sequence = entity.methods.length;
      entity.methods.push(element);
      element.entity = entity;
    }
    return element;
  }

  /** 创建方法参数 */
  public static createMethodParameter(entity: EntityMethod | InterfaceMethod | ValueObjectMethod): MethodParameter {
    const element = new MethodParameter();
    this.setBaseElementAsync(element, 'methodParameter', '新建方法参数');
    if (entity !== null) {
      element.sequence = entity.parameters.length;
      entity.parameters.push(element);
      if (entity instanceof EntityMethod) {
        element.entityMethod = entity;
      } else if (entity instanceof InterfaceMethod) {
        element.interfaceMethod = entity;
      } else if (entity instanceof ValueObjectMethod) {
        element.valueObjectMethod = entity;
      }
    }
    return element;
  }

  /** 创建接口 */
  public static createInterface(component: BEComponent, isJoinComponent: boolean): BEInterface {
    const bEInterface = new BEInterface();
    this.setBaseElementAsync(bEInterface, 'Interface', '新建接口');
    if (component !== null) {
      if (isJoinComponent) {
        component.interfaces.push(bEInterface);
      }
      bEInterface.component = component;
    }
    return bEInterface;
  }

  /** 创建接口属性 */
  public static createInterfaceAttribute(beInterface: BEInterface): InterfaceAttribute {
    const element = new InterfaceAttribute();
    this.setBaseElementAsync(element, 'Attribute', '新建属性');
    if (beInterface !== null) {
      element.sequence = beInterface.attributes.length;
      beInterface.attributes.push(element);
      element.interface = beInterface;
    }
    return element;
  }

  /** 创建接口方法 */
  public static createInterfaceMethod(beInterface: BEInterface): InterfaceMethod {
    const element = new InterfaceMethod();
    this.setBaseElementAsync(element, 'method', '新建方法');
    if (beInterface !== null) {
      element.sequence = beInterface.methods.length;
      beInterface.methods.push(element);
      element.interface = beInterface;
    }
    return element;
  }

  /** 创建枚举 */
  public static createEnum(component: BEComponent, isJoinComponent: boolean): BEEnum {
    const bEEnum = new BEEnum();
    this.setBaseElementAsync(bEEnum, 'Enum', '新建枚举');
    if (component !== null) {
      if (isJoinComponent) {
        component.enums.push(bEEnum);
      }
      bEEnum.component = component;
    }
    return bEEnum;
  }

  /** 创建枚举项 */
  public static createEnumItem(beEnum: BEEnum): EnumItem {
    const element = new EnumItem();
    this.setBaseElementAsync(element, 'EnumItem', '新建枚举项');
    if (beEnum !== null) {
      element.sequence = beEnum.enumItems.length;
      let maxValue = 0;
      beEnum.enumItems.forEach(item => {
        if (item.itemValue > maxValue) {
          maxValue = item.itemValue;
        }
      });
      if (maxValue === 0) {
        element.itemValue = 1;
      } else {
        element.itemValue = 2 * maxValue;
      }
      beEnum.enumItems.push(element);
      element.enum = beEnum;
    }
    return element;
  }

  /** 创建商业逻辑 */
  public static createBusinessLogic(component: BEComponent, isJoinComponent: boolean): BEBusinessLogic {
    const element = new BEBusinessLogic();
    this.setBaseElementAsync(element, 'BLName', '新建商业逻辑');
    if (component !== null) {
      if (isJoinComponent) {
        component.businessLogics.push(element);
      }
      element.component = component;
    }
    return element;
  }

  /** 创建商业逻辑参数 */
  public static createBLParameter(bl: BEBusinessLogic): BLParameter {
    const element = new BLParameter();
    this.setBaseElementAsync(element, 'parameter', '新建参数');
    if (bl !== null) {
      element.sequence = bl.parameters.length;
      bl.parameters.push(element);
      element.businessLogic = bl;
    }
    return element;
  }

  /** 创建DTO */
  public static createDTO(component: BEComponent, isJoinComponent: boolean): BEDTO {
    const element = new BEDTO();
    this.setBaseElementAsync(element, 'DTO', '新建DTO');
    if (component !== null) {
      if (isJoinComponent) {
        component.dTOes.push(element);
      }
      element.component = component;
    }
    return element;
  }

  /** 创建DTO属性 */
  public static createDTOAttribute(dto: BEDTO): DTOAttribute {
    const element = new DTOAttribute();
    this.setBaseElementAsync(element, 'Attribute', '新建属性');
    if (dto !== null) {
      element.sequence = dto.attributes.length;
      dto.attributes.push(element);
      element.dTO = dto;
    }
    return element;
  }

  /** 从实体创建DTO */
  public static createDTOFromEntity(component: BEComponent, entity: BEEntity, isJoinComponent: boolean): BEDTO {
    const element = new BEDTO();
    this.setBaseElementAsync(element, entity.name + 'dto', entity.displayName + 'DTO');
    element.description = entity.description;
    entity.attributes.forEach(attribute => {
      const dtoAttr = new DTOAttribute();
      this.setBaseElementAsync(dtoAttr, attribute.name, attribute.displayName);
      dtoAttr.dataType = attribute.dataType;
      dtoAttr.defaultValue = attribute.defaultValue;
      dtoAttr.description = attribute.description;
      dtoAttr.groupName = attribute.groupName;
      dtoAttr.isCollection = attribute.isCollection;
      dtoAttr.isNullable = attribute.isNullable;
      dtoAttr.isReadOnly = attribute.isReadOnly;
      dtoAttr.isValidate = attribute.isValidate;
      dtoAttr.maxValue = attribute.maxValue;
      dtoAttr.minValue = attribute.minValue;
      dtoAttr.referenceType = attribute.referenceType;
      dtoAttr.status = attribute.status;

      dtoAttr.dTO_ID = element.id;
      element.attributes.push(dtoAttr);
    });
    if (component !== null) {
      if (isJoinComponent) {
        component.dTOes.push(element);
      }
      element.component = component;
    }
    return element;
  }

  /** 创建值对象 */
  public static createValueObject(component: BEComponent, isJoinComponent: boolean): BEValueObject {
    const valueObject = new BEValueObject();
    this.setBaseElementAsync(valueObject, 'ValueObject', '新建值对象');
    if (component !== null) {
      if (isJoinComponent) {
        component.valueObjects.push(valueObject);
      }
      valueObject.component = component;
    }
    return valueObject;
  }

  /** 创建值对象属性 */
  public static createValueObjectAttribute(valueObject: BEValueObject): ValueObjectAttribute {
    const element = new ValueObjectAttribute();
    this.setBaseElementAsync(element, 'Attribute', '新建属性');
    if (valueObject !== null) {
      element.sequence = valueObject.attributes.length;
      valueObject.attributes.push(element);
      element.valueObject = valueObject;
    }
    return element;
  }

  /** 创建值对象方法 */
  public static createValueObjectMethod(valueObject: BEValueObject): ValueObjectMethod {
    const element = new ValueObjectMethod();
    this.setBaseElementAsync(element, 'method', '新建方法');
    if (valueObject !== null) {
      element.sequence = valueObject.methods.length;
      valueObject.methods.push(element);
      element.valueObject = valueObject;
    }
    return element;
  }

  /** 创建服务 */
  public static createService(component: BEComponent, isJoinComponent: boolean): BEService {
    const element = new BEService();
    this.setBaseElementAsync(element, 'Service', '新建服务');
    if (component !== null) {
      if (isJoinComponent) {
        component.services.push(element);
      }
      element.component = component;
    }
    return element;
  }

  /** 创建服务操作 */
  public static createBEServiceAction(service: BEService): BEServiceAction {
    const element = new BEServiceAction();
    this.setBaseElementAsync(element, 'ServiceAction', '新建服务操作');
    if (service !== null) {
      element.sequence = service.serviceActions.length;
      service.serviceActions.push(element);
      element.service = service;
    }
    return element;
  }

  /** 创建外部服务 */
  public static createExternalService(component: BEComponent, isJoinComponent: boolean): BEExternalService {
    const element = new BEExternalService();
    this.setBaseElementAsync(element, 'ExternalService', '新建外部服务');
    if (component !== null) {
      if (isJoinComponent) {
        component.externalServices.push(element);
      }
      element.component = component;
    }
    return element;
  }

  /** 创建外部服务参数 */
  public static createESParameter(es: BEExternalService): ESParameter {
    const element = new ESParameter();
    this.setBaseElementAsync(element, 'parameter', '新建外部服务参数');
    if (es !== null) {
      element.sequence = es.parameters.length;
      es.parameters.push(element);
      element.externalService = es;
    }
    return element;
  }

  /** 创建新的外部服务参数 */
  public static createNewESParameter(es: BEExternalService, name: string, displayName: string, description: string, dataType: EnumDataType, isNullable: boolean): ESParameter {
    const element = this.createESParameter(es);
    element.name = name;
    element.displayName = displayName;
    element.description = description;
    element.dataType = dataType;
    element.isNullable = isNullable;
    return element;
  }

  /** 创建分布式事务 */
  public static createDistributedTransaction(component: BEComponent, isJoinComponent: boolean): BEDistributedTransaction {
    const element = new BEDistributedTransaction();
    this.setBaseElementAsync(element, 'DistributedTransaction', '新建分布式事务');
    if (component !== null) {
      if (isJoinComponent) {
        component.distributedTransactions.push(element);
      }
      element.component = component;
    }
    return element;
  }

  /** 创建分布式事务属性 */
  public static createDTAttribute(dt: BEDistributedTransaction): DTAttribute {
    const element = new DTAttribute();
    this.setBaseElementAsync(element, 'Attribute', '新建属性');
    if (dt !== null) {
      element.sequence = dt.attributes.length;
      dt.attributes.push(element);
      element.distributedTransaction = dt;
    }
    return element;
  }

  /** 创建常量 */
  public static createConstant(component: BEComponent, isJoinComponent: boolean): BEConstant {
    const element = new BEConstant();
    this.setBaseElementAsync(element, 'Constant', '新建常量');
    if (component !== null) {
      if (isJoinComponent) {
        component.constants.push(element);
      }
      element.component = component;
    }
    return element;
  }

  /** 创建常量项 */
  public static createConstantItem(constant: BEConstant): ConstantItem {
    const element = new ConstantItem();
    this.setBaseElementAsync(element, 'configItem', '新建配置项');
    if (constant !== null) {
      element.sequence = constant.items.length;
      constant.items.push(element);
      element.constant = constant;
    }
    return element;
  }

  /** 创建引用实体 */
  public static createReferenceEntity(component: BEComponent, isJoinComponent: boolean): BEReferenceEntity {
    const referenceEntity = new BEReferenceEntity();
    this.setBaseElementAsync(referenceEntity, 'ReferenceEntity', '新建引用实体');
    referenceEntity.description = '请选择引用的实体';
    if (component !== null) {
      if (isJoinComponent) {
        component.referenceEntities.push(referenceEntity);
      }
      referenceEntity.component = component;
    }
    return referenceEntity;
  }

  /**
   * 创建实体继承关系
   * @param component BE组件
   * @param superEntity 父实体
   * @param subEntity 子实体
   */
  public static createEntityGeneration(component: BEComponent, superEntity: BEEntity, subEntity: BEEntity, isJoinComponent: boolean): EntityGeneration {
    const entityGeneration = new EntityGeneration();
    this.setBaseElementAsync(entityGeneration, 'EntityGeneration', '实体继承关系');
    entityGeneration.relationshipType = EnumRelationshipType.EntityGeneralization;
    entityGeneration.superEntity = superEntity;
    entityGeneration.subEntity = subEntity;
    if (component !== null) {
      if (isJoinComponent) {
        component.entityGenerations.push(entityGeneration);
      }
      entityGeneration.component = component;
    }
    return entityGeneration;
  }

  /**
   * 创建接口继承关系
   * @param component BE组件
   * @param superInterface 父接口
   * @param subInterface 子接口
   */
  public static createInterfaceGeneration(component: BEComponent, superInterface: BEInterface, subInterface: BEInterface, isJoinComponent: boolean): InterfaceGeneration {
    const interfaceGeneration = new InterfaceGeneration();
    this.setBaseElementAsync(interfaceGeneration, 'InterfaceGeneration', '接口继承关系');
    interfaceGeneration.relationshipType = EnumRelationshipType.InterfaceGeneralization;
    interfaceGeneration.superInterface = superInterface;
    interfaceGeneration.subInterface = subInterface;
    if (component !== null) {
      if (isJoinComponent) {
        component.interfaceGenerations.push(interfaceGeneration);
      }
      interfaceGeneration.component = component;
    }
    return interfaceGeneration;
  }

  /**
   * 创建实体关联关系,01对0多
   * @param component BE组件
   * @param sourceEntity 源实体
   * @param targetEntity 目标实体
   */
  public static createAssociation(component: BEComponent, sourceEntity: BEEntity, targetEntity: BEEntity, isJoinComponent: boolean): Association {
    const association = new Association();
    this.setBaseElementAsync(association, 'EntityAssociation', '实体关联关系');
    association.relationshipType = EnumRelationshipType.Association;
    association.sourceEntity = sourceEntity;
    association.sourceMultiplicity = EnumMultiplicity.ZeroMany;
    association.targetEntity = targetEntity;
    association.targetMultiplicity = EnumMultiplicity.ZeroOne;
    if (component !== null) {
      if (isJoinComponent) {
        component.associations.push(association);
      }
      association.component = component;
    }
    console.log('create association, source:' + sourceEntity + ', target:' + targetEntity);
    return association;
  }

  /**
   * 创建实体依赖关系
   * @param component BE组件
   * @param sourceEntity 源实体
   * @param targetEntity 目标实体
   */
  public static createDependencyAssociation(component: BEComponent, sourceEntity: BEEntity, targetEntity: BEEntity, isJoinComponent: boolean): DependencyAssociation {
    const dependency = new DependencyAssociation();
    this.setBaseElementAsync(dependency, 'EntityDependency', '实体依赖关系');
    dependency.relationshipType = EnumRelationshipType.Dependency;
    dependency.sourceEntity = sourceEntity;
    dependency.sourceMultiplicity = EnumMultiplicity.ZeroMany;
    dependency.targetEntity = targetEntity;
    dependency.targetMultiplicity = EnumMultiplicity.ZeroOne;
    dependency.sourceIsNavigation = false; // 源不能导航，只需要设置目标对应的属性即可。
    if (component !== null) {
      if (isJoinComponent) {
        component.dependencyAssociations.push(dependency);
      }
      dependency.component = component;
    }
    return dependency;
  }

  /**
   * 创建实体组合关系
   * @param component BE组件
   * @param sourceEntity 源实体
   * @param targetEntity 目标实体
   */
  public static createComposition(component: BEComponent, sourceEntity: BEEntity, targetEntity: BEEntity, isJoinComponent: boolean): Composition {
    const composition = new Composition();
    this.setBaseElementAsync(composition, 'EntityComposition', '实体组合关系');
    composition.relationshipType = EnumRelationshipType.Composition;
    composition.sourceEntity = sourceEntity;
    composition.sourceMultiplicity = EnumMultiplicity.One;
    composition.targetEntity = targetEntity;
    composition.targetMultiplicity = EnumMultiplicity.ZeroMany;
    if (component !== null) {
      if (isJoinComponent) {
        component.compositions.push(composition);
      }
      composition.component = component;
    }
    return composition;
  }

  /**
   * 创建实体聚合关系
   * @param component BE组件
   * @param sourceEntity 源实体
   * @param targetEntity 目标实体
   */
  public static createAggregation(component: BEComponent, sourceEntity: BEEntity, targetEntity: BEEntity, isJoinComponent: boolean): Aggregation {
    const aggregation = new Aggregation();
    this.setBaseElementAsync(aggregation, 'EntityAggregation', '实体聚合关系');
    aggregation.relationshipType = EnumRelationshipType.Aggregation;
    aggregation.sourceEntity = sourceEntity;
    aggregation.sourceMultiplicity = EnumMultiplicity.ZeroOne;
    aggregation.targetEntity = targetEntity;
    aggregation.targetMultiplicity = EnumMultiplicity.ZeroMany;
    if (component !== null) {
      if (isJoinComponent) {
        component.aggregations.push(aggregation);
      }
      aggregation.component = component;
    }
    return aggregation;
  }

  /**
   * 创建实体交叉关系
   * @param component BE组件
   * @param sourceEntity 源实体
   * @param targetEntity 目标实体
   */
  public static createCrossAssociation(component: BEComponent, sourceEntity: BEEntity, targetEntity: BEEntity, isJoinComponent: boolean): CrossAssociation {
    const cross = new CrossAssociation();
    this.setBaseElementAsync(cross, 'EntityCrossAssociation', '实体交叉关系');
    cross.relationshipType = EnumRelationshipType.CrossAssociation;
    cross.sourceEntity = sourceEntity;
    cross.sourceMultiplicity = EnumMultiplicity.OneMany;
    cross.targetEntity = targetEntity;
    cross.targetMultiplicity = EnumMultiplicity.OneMany;
    if (component !== null) {
      if (isJoinComponent) {
        component.crossAssociations.push(cross);
      }
      cross.component = component;
    }
    return cross;
  }

  /**
   * 创建实体实现接口关系
   * @param component BE组件
   * @param entity 实体
   * @param bEinterface 接口
   */
  public static createImplement(component: BEComponent, entity: BEEntity, bEinterface: BEInterface, isJoinComponent: boolean): Implement {
    const implement = new Implement();
    this.setBaseElementAsync(implement, 'EntityImplementInterface', '实体实现接口关系');
    implement.relationshipType = EnumRelationshipType.Implement;
    implement.entity = entity;
    implement.interface = bEinterface;
    if (component !== null) {
      if (isJoinComponent) {
        component.implements.push(implement);
      }
      implement.component = component;
    }
    return implement;
  }

  /** ************************************************************* UIModel ********************************************** */
  /** 创建视图对象属性 */
  public static createEVOAttribute(viewObject: ViewObject): EVOAttribute {
    const element = new EVOAttribute();
    this.setBaseElementAsync(element, 'Attribute', '新建属性');
    if (viewObject !== null) {
      viewObject.attributes.push(element);
      element.viewObject = viewObject;
    }
    return element;
  }

  /** 创建视图对象操作 */
  public static createEVOAction(viewObject: ViewObject, actionType: ActionType): EVOAction {
    const element = new EVOAction();
    this.setBaseElementAsync(element, actionType.name, actionType.displayName);
    element.actionType = actionType;
    if (viewObject !== null) {
      viewObject.actions.push(element);
      element.viewObject = viewObject;
    }
    return element;
  }

  /** 创建自定义页面分组 */
  public static createUIPageGroup(uiModelComponent: UIModelComponent): UIPageGroup {
    const element = new UIPageGroup();
    this.setBaseElementAsync(element, 'PageGroup', '新建页面分组');
    element.bindingCode = '';
    if (uiModelComponent !== null) {
      element.component = uiModelComponent;
      uiModelComponent.pageGroups.push(element);
    }
    return element;
  }

  /** 创建自定义页面 */
  public static createUIPage(pageGroup: UIPageGroup): UIPage {
    const element = new UIPage();
    this.setBaseElementAsync(element, 'Page', '新建页面');
    element.pageType = EnumPageType.Custom;
    element.title = '新建页面';
    element.needLogin = true;
    element.bindingCode = '';
    element.filename = element.name;
    if (pageGroup !== null) {
      element.pageGroup = pageGroup;
      pageGroup.pages.push(element);
    }
    return element;
  }

  /** 创建注释 */
  private static setComment(comment: BaseComment): BaseComment {
    this.setBaseElementAsync(comment, 'Comment', '注释');
    comment.text = '请添加注释';
    return comment;
  }

  /** 设置元数据基类的初始属性 */
  private static async setBaseElementAsync(element: BaseElement, name: string, displayName: string): Promise<string> {
    element.designId = GuidHelper.getGuid();
    element.persistenceStatus = EnumPersistenceStatus.Create;
    element.name = name;
    element.displayName = displayName;
    element.createdBy = IDEContext.instance.curAccountInfo.accountId;
    element.owner = IDEContext.instance.curUser.tenancy_ID;
    if (IDEContext.instance.curAccountInfo !== null) {
      element.createdBy = IDEContext.instance.curAccountInfo.accountId;
    }
    element.id = UniqueKeyManager.instance.getUniqueKey();
    return new Promise((resolve, reject) => {
      resolve(element.id);
    });
  }
}
